import { HStack, Image, Text, VStack } from "@chakra-ui/react";
import React from "react";

export const Banner = () => {
  return (
    <HStack
      h={['100vh', '100vh', "70%"]}
      justifyContent="space-between"
      position="relative"
      height={"full"}
      pt={["60px", "60px", "0px"]}
    >
      <Image
        src="/backgroundIlustration.png"
        position="absolute"
        left={0}
        top={0}
      />
      <VStack
        mt={"15%"}
        mb={"90%"}
        w="full"
        h="full"
        bgColor="primary.1000"
        justifyContent="center"
        alignItems="center"
      >
        <Text
          fontSize={["xx-large", "xx-large", "xxx-large"]}
          lineHeight="unset"
          fontWeight="bold"
          color="#fff"
          zIndex={999}
        >
          Viajá seguro, viajá legal
        </Text>
        <Text
          fontSize={["large", "large", "md"]}
          lineHeight="unset"
          w="80%"
          textAlign="center"
          color="primary.400"
          px={[0, 0, 20]}
          zIndex={999}
        >
          Hacé match con conductores habilitados y empezá a viajar con
          tranquilidad y seguridad.
        </Text>
        <Image
          src="/iphones.png"
          transform={["scale(1)", "scale(1)", "scale(0.8)"]}
          mt={0}
          zIndex={[9,9,9999]}
          position={"absolute"}
          top={[72, 72, 60]}
        />
      </VStack>
    </HStack>
  );
};
